<template>
  <div class="dsf_nc_title" :style="{ padding: padding }">
    <div class="title-inner">
      <div class="title-wrap">
        <h3 class="title">{{ title }}</h3>
        <div class="title-more">
          <span slot="more" @click="_clickBefore(toUrl)">更多>></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfNcTitle",
  ctrlCaption: "门户标题",
  mixins: [$mixins.control],
  props: {
    title: {
      type: String,
      default: "标题",
    },
    moreUrl: {
      type: String,
      default: "",
    },
    padding: {
      type: String,
      default: "50px 0 10px 0",
    },
  },
  data() {
    return {};
  },
  created() {
    console.log(this.margin);
  },
  methods: {
    toUrl() {
      this.$router.push(this.moreUrl);
    },
    _clickBefore(next, ...params) {
      if (this.isDesign) return;
      let res = this.$checkLogin();
      if (res && res.then) {
        res.then(r => {
          if (r !== false) {
            next(...params);
          }
        });
      } else if (res !== false) {
        next(...params);
      }
    },
  },
});
</script>
